import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";


export const ExtractAudio = () => {
    const [videoFile, setVideoFile] = useState(null);
    const [videoUrl, setVideoUrl] = useState("");
    const [audioUrl, setAudioUrl] = useState("");

    const onDrop = (acceptedFiles) => {
        const file = acceptedFiles[0];
        setVideoFile(file);
        setVideoUrl(URL.createObjectURL(file));

        // Upload the video to the server
        const formData = new FormData();
        formData.append("video", file);

        axios
            .post(`${process.env.REACT_APP_API_URL}/audio-extract`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                setAudioUrl(response.data.audioUrl);
            })
            .catch((error) => {
                console.error("Error uploading video:", error);
            });
    };

    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    return (
        <div>
            <h1 style={{ textAlign: "center", padding: "20px" }}>Video Editing Tool - Extract Audio</h1>
            <div
                {...getRootProps()}
                style={{
                    border: "2px dashed #ccc",
                    padding: "20px",
                    textAlign: "center",
                    cursor: "pointer",
                }}
            >
                <input {...getInputProps()} />
                <p>Drag & drop a video here, or click to select one</p>
            </div>
            {videoUrl && (
                <div>
                    <h3>Video Player:</h3>
                    <video controls src={videoUrl} style={{ width: "100%", maxHeight: "400px" }} />
                </div>
            )}
            {audioUrl && (
                <div>
                    <h3>Extracted Audio:</h3>
                    <audio controls src={audioUrl} />
                </div>
            )}
        </div>
    );
}
